import ArrowDropUpOutlinedIcon from '@mui/icons-material/ArrowDropUpOutlined';
import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import { Typography, Box } from "@mui/material";

// 👇 이 안에서 rankChange 를 조건에 따라 아이콘 + 텍스트로 렌더링
export function CustomRankChangeCell({ rankChange }) {
    const commonBoxStyle = {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 2,
        px: 1,
        py: 0.3,
        minWidth: 50,
        height: 26, // ✅ 높이 고정
        fontSize: "12px",
        lineHeight: 1
      };
    if (rankChange === 999) {
        return (
            <Box sx={{ ...commonBoxStyle, backgroundColor: "#e8f5e9", gap:0.5 }}>
                <AddCircleOutlinedIcon color="primary" fontSize="medium" sx={{color: "green", fontSize: 9 }}/>
                <Typography sx={{fontSize:"8px", fontWeight:"bold"}}>NEW</Typography>
            </Box>
        );
    }

    if (rankChange > 0) {
        return (
            <Box sx={{ ...commonBoxStyle, backgroundColor: "#ffebee" }}>
                <ArrowDropUpOutlinedIcon sx={{ color: "red" }} fontSize="medium" />
                <Typography fontSize="9px">{rankChange}</Typography>
            </Box>
        );
    }

    if (rankChange < 0) {
        return (
            <Box sx={{ ...commonBoxStyle, backgroundColor: "#e3f2fd" }}>
                <ArrowDropDownOutlinedIcon sx={{ color: "blue" }} fontSize="medium" />
                <Typography fontSize="9px">{Math.abs(rankChange)}</Typography>
            </Box>
        );
    }

    // rankChange === 0
    return (
        <Box sx={{ ...commonBoxStyle, backgroundColor: "#e0e0e0" }}>
            <Typography sx={{fontSize:"20px", fontWeight:"bold"}}>-</Typography>
        </Box>
    );
}
